import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { FinishTrainingGuideIcon } from '../../../../assets';
import { PrimaryButton } from '../../../../components';
import { useTranslate } from '../../../../translations';
import { FinishTrainingGuideProps } from '../../types';
import { useStyles } from './styles';
import { Brand } from '../../../../hooks/useSelectBrand';

export const FinishTrainingGuide: React.FC<FinishTrainingGuideProps> = ({ title }) => {
  const t = useTranslate();
  const styles = useStyles();
  let params = useParams();

  const brandParam = (params?.brand?.toLocaleUpperCase() as Brand) || '';
  return (
    <Stack direction="row" justifyContent="center" className={styles.container}>
      <Box className={styles.contentContainer}>
        <FinishTrainingGuideIcon className={styles.image} />
        <Typography variant="h6" className={styles.title}>
          {title}
        </Typography>
        <Link to={`/${brandParam.toLocaleLowerCase()}`} className={styles.link}>
          <PrimaryButton className={styles.button}>{t('wiki.receipt.finish.back-to-trainings')}</PrimaryButton>
        </Link>
      </Box>
    </Stack>
  );
};
